<script setup lang="ts">
import { useOfflineStore } from '../stores/offlineStore';

const offlineStore = useOfflineStore();

const formatDate = (date: Date) => {
  return new Intl.DateTimeFormat('es-AR', {
    dateStyle: 'short',
    timeStyle: 'short'
  }).format(date);
};
</script>

<template>
  <div 
    class="fixed bottom-4 left-4 px-4 py-2 rounded-lg shadow-lg z-50"
    :class="[
      offlineStore.isOnline 
        ? 'bg-green-50 text-green-700' 
        : 'bg-amber-50 text-amber-700'
    ]"
  >
    <div class="flex items-center space-x-2">
      <div 
        class="w-2 h-2 rounded-full"
        :class="[
          offlineStore.isOnline 
            ? 'bg-green-500' 
            : 'bg-amber-500'
        ]"
      />
      <span class="text-sm font-medium">
        {{ offlineStore.isOnline ? 'En línea' : 'Fuera de línea' }}
      </span>
    </div>
    <div v-if="!offlineStore.isOnline && offlineStore.lastSync" class="text-xs mt-1">
      Última sincronización: {{ formatDate(offlineStore.lastSync) }}
    </div>
  </div>
</template>